/* =========================================================
   Sudha Oils — Shopify Sections JavaScript
   ========================================================= */

(function () {
  'use strict';

  // ---------------- Scroll reveal (IntersectionObserver) ----------------
  const initReveal = () => {
    const revealEls = document.querySelectorAll('.shopify-section-sudha .reveal, .shopify-section-sudha .reveal-stagger');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add('in');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
      );
      revealEls.forEach((el) => io.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('in'));
    }
  };

  // ---------------- FAQ accordion ----------------
  const initFAQ = () => {
    document.querySelectorAll('.shopify-section-sudha .faq-item').forEach((item) => {
      const q = item.querySelector('.faq-q');
      if (!q) return;
      
      // Remove any existing listener to avoid double-binding on Shopify reload
      const newQ = q.cloneNode(true);
      q.parentNode.replaceChild(newQ, q);

      newQ.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        item.parentElement.querySelectorAll('.faq-item.open').forEach((sib) => {
          if (sib !== item) sib.classList.remove('open');
        });
        item.classList.toggle('open', !isOpen);
      });
    });
  };

  // ---------------- Contact form validation ----------------
  const initContactForm = () => {
    const contactForm = document.querySelector('.shopify-section-sudha [data-testid="contact-form"]');
    if (contactForm) {
      const setError = (group, hasError) => group.classList.toggle('invalid', hasError);
      const status = contactForm.querySelector('.form-status');

      contactForm.addEventListener('submit', (e) => {
        let ok = true;
        contactForm.querySelectorAll('.form-group').forEach((group) => {
          const field = group.querySelector('input, textarea, select');
          if (!field) return;
          let invalid = false;
          if (field.hasAttribute('required') && !field.value.trim()) invalid = true;
          if (field.type === 'email' && field.value.trim()) {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim())) invalid = true;
          }
          setError(group, invalid);
          if (invalid) ok = false;
        });

        if (!ok) {
          e.preventDefault();
          if (status) {
            status.style.color = '#b14a3a';
            status.textContent = 'Please fix the highlighted fields.';
          }
        }
      });

      contactForm.querySelectorAll('input, textarea, select').forEach((f) => {
        f.addEventListener('input', () => f.parentElement.classList.remove('invalid'));
      });
    }
  };

  // Initial load
  const initAll = () => {
    initReveal();
    initFAQ();
    initContactForm();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme customizer reload handling
  document.addEventListener('shopify:section:load', function (event) {
    initAll();
  });
})();
